import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormCheck, FormInput } from "go-form";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { FormDirty } from "go-form/components/FormDirty";
import { apiOrganization } from "../../../../../../../../../../../services/Api/Organization/apiOrganization";
import { OtherVenueSettingsApi } from "../../../../../../../../../../../services/Api/Organization/types";

interface Props {
	settings: OtherVenueSettingsApi;
}

const OthersForm = ({ settings }: Props) => {
	const form = useForm<OtherVenueSettingsApi>({
		criteriaMode: "all",
		defaultValues: {
			settings: settings.settings.map((setting) => ({
				...setting,
				value: setting.value === "true",
			})),
		},
	});
	const { handleSubmit, formState, register, reset, setError, watch } = form;
	const [loading, setLoading] = useState(false);
	const { t } = useTranslation();
	const { addFlash, addSuccessFlash } = useFlash();

	const onSubmit = handleSubmit(async (data) => {
		setLoading(true);
		try {
			const res = await apiOrganization.updateOtherVenueSettings(data);
			reset({
				...res,
				settings: res.settings.map((setting) => ({
					...setting,
					value: setting.value === "true",
				})),
			});
			addSuccessFlash(t("lib:common.flash.saved"));
		} catch (err) {
			handleError.form(err, setError, addFlash);
		}
		setLoading(false);
	});

	return (
		<FormDirty onSubmit={onSubmit} loading={loading} formState={formState}>
			{watch("settings").map((setting, index) => (
				<>
					<FormInput
						name={`settings.${index}.type`}
						errors={[]}
						register={register}
						type="hidden"
						defaultValue={setting.type}
					/>
					<FormCheck
						name={`settings.${index}.value`}
						errors={[]}
						register={register}
						label={t(`modules.setting.field.${setting.type.toLocaleLowerCase()}.title`)}
						type="switch"
					/>
				</>
			))}
		</FormDirty>
	);
};

export default OthersForm;

// t("modules.setting.field.websocket_changes_enabled.title")
